import Swiper from "swiper";
import {
	casseroleRound
} from "./modules/product/casserole_round";
import {
	casseroleOval
} from "./modules/product/casserole_oval";
import {
	fryingPan
} from "./modules/product/fryingPan";
import {
	other
} from "./modules/product/other";

var swiper = new Swiper(".swiper-container", {
	loop: true,
	slidesPerView: 2,
	spaceBetween: 20,
	centeredSlides: true,
	allowTouchMove: false,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	breakpoints: {
		768: {
			slidesPerView: 4,
			spaceBetween: 10,
		},
	},
});

// product modal
const productItem = document.querySelectorAll(".js-productItem");
const modalProduct = document.querySelector(".js-modalProduct");
const overlay = document.querySelector(".js-modalOverlay");

const productItemNode = Array.prototype.slice.call(productItem, 0);

productItemNode.forEach((targetBox) => {
	targetBox.addEventListener("click", () => {
		// モーダルの表示・非表示
		if (modalProduct.classList.contains("is-view")) {
			document.querySelector("body").classList.remove("is-fixed");
			overlay.classList.remove("is-view");
			modalProduct.classList.remove("is-view");
		} else {
			// 型番取得
			const productId = targetBox.getAttribute("data-id");
			casseroleRound(productId);
			casseroleOval(productId);
			fryingPan(productId);
			other(productId);

			document.querySelector("body").classList.add("is-fixed");
			overlay.classList.add("is-view");
			modalProduct.classList.add("is-view");
		}
	});
});